import React, { useState, useEffect } from 'react';
import * as Auth from "../../Login/Auth"
import { ContentBox } from '../Content/ContentBox';
import { ReqSystemPrompt } from '../../../item/ItemSystem';
import { addPrompt, getPrompt, addManagementPrompt, getManagementPrompt } from '../../../api/apiSystem';
import { getMenuActiveId, getPageLink } from '../../Menu/MenuConfig';
import Swal from 'sweetalert2';
import { ReqPageId } from '../../../item/ItemPage';
import { api_getPageId } from '../../../api/apiPage';
import { SingleTextArea } from './BaseInput';

export function ManagementPrompt() {
    const [promptText, setPromptText] = useState("")
    const [accountId, setAccountId] = useState("")
    const [pageId, setPageId] = useState("")

    useEffect(() => {
        var userInfo = Auth.getUserInfo()
        //console.log(userInfo)
        setAccountId(userInfo.accountId)

        var menuId = getMenuActiveId()
        var pageLink = getPageLink()

        var mReqPageId = new ReqPageId({
            pageLink,
            menuId
        })
        getPageId(mReqPageId)

    }, [])



    function getPageId(mReqPageId) {

        api_getPageId({
            mReqPageId,
            success: (jsonDate) => {
                setPageId(jsonDate.pageId)
                get(jsonDate.pageId)
            },
            failure: (err) => {

            }
        })
    };

    async function save() {

        var mReqSystemPrompt = new ReqSystemPrompt({
            pageId,
            promptText: encodeURI(promptText),
            accountId
        })
        //console.log(mReqSystemPrompt)
        try {
            await addManagementPrompt({ mReqSystemPrompt })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: '更新成功',
            })
        } catch (error) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '更新失敗',
            })
        }
    }

    function get(pageId) {
        getManagementPrompt({
            pageId,
            success: (mReqSystemPrompt) => {
                //console.log(mReqSystemPrompt)
                setPromptText(decodeURI(mReqSystemPrompt.promptText))
            },
            failure: (err) => {

            }
        })
    }


    var title = "管理部提示"
    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => save()}>
            <i className="fa fa-floppy-o text-info"></i><span className="text-info m-l-xs">儲存</span>
        </a>
    var content =
        <div className="row">
            <div className="col-md-12">
                <SingleTextArea val={promptText} action={setPromptText} />
            </div>
        </div>
    return (
        <ContentBox title={title} title_tools={title_tools} content={content} hasDrawer={false} />
    )
}